import { defineComponent as n, h as r } from "vue";
import { useCarouselContext as c } from "./ghl-ui.es926.js";
import d from "./ghl-ui.es854.js";
const u = r("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, r("g", {
  fill: "none"
}, r("path", {
  d: "M10.26 3.2a.75.75 0 0 1 .04 1.06L6.773 8l3.527 3.74a.75.75 0 1 1-1.1 1.02l-4-4.25a.75.75 0 0 1 0-1.02l4-4.25a.75.75 0 0 1 1.06-.04z",
  fill: "currentColor"
}))), w = r("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, r("g", {
  fill: "none"
}, r("path", {
  d: "M5.74 3.2a.75.75 0 0 0-.04 1.06L9.227 8L5.7 11.74a.75.75 0 1 0 1.1 1.02l4-4.25a.75.75 0 0 0 0-1.02l-4-4.25a.75.75 0 0 0-1.06-.04z",
  fill: "currentColor"
}))), p = n({
  name: "CarouselArrow",
  setup(e) {
    const {
      mergedClsPrefixRef: o
    } = d(e), {
      isVertical: s,
      isPrevDisabled: l,
      isNextDisabled: a,
      prev: t,
      next: i
    } = c();
    return {
      mergedClsPrefix: o,
      isVertical: s,
      isPrevDisabled: l,
      isNextDisabled: a,
      prev: t,
      next: i
    };
  },
  render() {
    const {
      mergedClsPrefix: e
    } = this;
    return r("div", {
      class: `${e}-carousel__arrow-group`
    }, r("div", {
      class: [`${e}-carousel__arrow`, this.isPrevDisabled() && `${e}-carousel__arrow--disabled`],
      role: "button",
      onClick: this.prev
    }, u), r("div", {
      class: [`${e}-carousel__arrow`, this.isNextDisabled() && `${e}-carousel__arrow--disabled`],
      role: "button",
      onClick: this.next
    }, w));
  }
});
export {
  p as default
};
